import React, { Component } from 'react'
import RichText from '../Form/RichText'
import Toggle from '../Form/toggle'
import { withSettings } from '../withSettings'

@withSettings
export default class QuickResponseTemplate extends Component {
  componentDidMount() {
    this.props.registerDataHandler(data => {
      return this.props.setSettingsAt('email.quick_response_template', data)
    })
  }

  render() {
    const { disabled, subject, body } = this.props.getSettingsAt('email.quick_response_template')
    const dynamicFields = this.props.getDynamicFieldsFor('quick_reponse')

    return (
      <div>
        <div className="form-section">
          <p className="muted">
            When a website visitor sends you a message, you can send an automatic
            response to let them know you'll be in touch shortly.
          </p>
        </div>
        <div className="form-section">
          <Toggle on={disabled} reverse={true} name="disabled">{disabled => (
              <strong>
                Quick Response emails are {disabled ? 'off' : 'on'}
              </strong>
            )}
          </Toggle>
        </div>
        <div className="form-section">
          <label>Subject</label>
          <RichText singleline name="subject" defaultValue={subject} dynamicFields={dynamicFields} />
        </div>

        <div className="form-section">
          <label>Message</label>
          <RichText name="body" defaultValue={body} dynamicFields={dynamicFields} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Email/QuickResponseTemplate.js